<div class="grid">
  <div class="cell cell-small-col-span-6 cell-medium-col-start-2 cell-large-col-span-6 cell-large-col-start-4">
    <div class="claim-detail-banner padding-small margin-horizontal-small">
      <button mat-icon-button (click)="goBack()">
        <mat-icon>west</mat-icon>
      </button>
      <div *ngIf="claimDetail">
        <h3 class="margin-top-xsmall" *ngIf="claimDetail?.eventTypeLabel">{{ claimDetail?.eventTypeLabel | titlecase }}</h3>
        <div>
          <open-badge *ngIf="claimDetail?.status" [label]="claimDetail?.status" [variant]="claimDetail?.statusVariant"></open-badge>
        </div>

        <div class="cell flex flex-row margin-top-medium">
          <div class="cell flex flex-column" *ngIf="claimDetail?.claimNumber">
            <span class="text-small text-white">Claim number</span>
            <span class="claim-detail-value">{{ claimDetail?.claimNumber }}</span>
          </div>
          <div class="cell flex flex-column margin-left-medium" *ngIf="claimDetail?.dateSubmitted">
            <span class="text-small text-white">Date submitted</span>
            <span class="claim-detail-value">{{ claimDetail?.dateSubmitted | displayDate }}</span>
          </div>
          <div class="cell flex flex-column margin-left-medium" *ngIf="!claimDetail?.dateSubmitted && claimDetail?.dateCreated">
            <span class="text-small text-white">Date created</span>
            <span class="claim-detail-value">{{ claimDetail?.dateCreated | displayDate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="grid align-center padding-bottom-xxbig">
  <div class="cell cell-small-col-span-6 cell-medium-col-start-2 cell-large-col-span-6 cell-large-col-start-4">
    <div class="form-typography margin-bottom-large">
      <div class="grid">
        <div class="cell cell-small-col-span-6 cell-large-col-span-12 padding-medium">

          <h3 class="margin-bottom-medium">Need help with your claim?</h3>
          <div class="content-card padding-small margin-bottom-large">
            <p class="font-bold">Managed by</p>
            <img [src]="claimDetail?.isTpaClaim ? (apiEndpoint + '/media/' + claimDetail?.tpaPartnerDetails?.logo_large) : 'assets/images/hollard/hollard-logo.jpg'" class="content-card-logo margin-bottom-small" alt="{{ claimDetail?.isTpaClaim ? claimDetail?.tpaPartnerDetails?.name :  'Hollard' }} logo">
            <p class="margin-bottom-medium">Your claim has been assigned to a specialist at {{ claimDetail?.isTpaClaim ? claimDetail?.tpaPartnerDetails?.name :  'Hollard' }}, who is handling your {{ claimDetail?.tpaClaimType }} claim.</p>
            <p class="margin-bottom-medium">They'll contact you by phone or email with updates whenever they have information on your claim.</p>
            <p class="margin-bottom-large" *ngIf="claimDetail?.tpaPartnerDetails?.support_phone_intl || claimDetail?.tpaPartnerDetails?.email">To update your claim or get help, use the links below.</p>
            <div *ngIf="claimDetail?.tpaPartnerDetails?.support_phone_intl">
              <button mat-flat-button  type="button" color="primary" mat-flat-button color="primary" (click)="dialPartnerNumber(claimDetail?.tpaPartnerDetails?.support_phone_intl)" [ngClass]="{ 'margin-bottom-medium': claimDetail?.tpaPartnerDetails?.email }">{{ claimDetail?.tpaPartnerDetails?.support_phone_intl }}</button>
            </div>
            <div *ngIf="claimDetail?.tpaPartnerDetails?.email">
              <button mat-flat-button  type="button" color="primary" mat-flat-button color="primary" (click)="openEmailClient(claimDetail?.tpaPartnerDetails?.email)">{{ claimDetail?.tpaPartnerDetails?.email }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
